import React from 'react'

export default function LongArrowIcon(): JSX.Element {
  return (
    <svg
      width="30"
      height="16"
      viewBox="0 0 30 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.7071 8.96297C30.0976 8.57245 30.0976 7.93928 29.7071 7.54876L23.3431 1.18479C22.9526 0.79427 22.3195 0.79427 21.9289 1.18479C21.5384 1.57532 21.5384 2.20848 21.9289 2.59901L27.5858 8.25586L21.9289 13.9127C21.5384 14.3032 21.5384 14.9364 21.9289 15.3269C22.3195 15.7175 22.9526 15.7175 23.3431 15.3269L29.7071 8.96297ZM0.174805 9.25586L29 9.25586L29 7.25586L0.174805 7.25586L0.174805 9.25586Z"
        fill="black"
      />
    </svg>
  )
}
